// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"M9-z"};